<template lang="pug">
  .component-backoffice-home
    .hide-for-small-only
      .row
        .columns
          .chart-parameters
            .row.filter-form
              .columns.small-12.medium-3
                date-range-picker(@input="dateRangeSelected", v-model="myRange")
              .columns.small-12.medium-3
                select(v-model="form.bracketing")
                  option(value="M") Monthly
                  option(value="W") Weekly
                  option(value="D") Daily
              .small-12.medium-3
                loading-animation(:loading="formLoading")
      .row.dashboard-stats
        .columns.large-6(v-if="$acl('charged-reservations-charts')")
          .inner-content.card
            h2 Charged reservations
            line-chart(v-if="res", :data="res")
        .columns.large-6(v-if="$acl('driven-distance-charts')")
          .inner-content.card
            h2 Total mileage
            line-chart(v-if="dis", :data="dis")
      .row.dashboard-stats
        .columns.large-6(v-if="$acl('driver-registrations-charts') && $acl('client-registrations-charts')")
          .inner-content.card
            h2 Registrations
            bar-chart(v-if="reg", :data="reg")
        .columns.large-6(v-if="$acl('vehicle-reservations-charts') && $acl('vehicle-distance-charts')")
          .inner-content.card
            h2 Vehicle allocation
            bar-chart(v-if="vei", :data="vei")
      .row.dashboard-stats(v-if="$acl('vehicles-by-zone-charts')")
        .column
          .inner-content.card
            h2 Vehicles per zone
            h3(v-if="this.loadingVeiByZ") loading...
            bar-chart(v-if="veiByZ" :data="veiByZ")
    home-controller
</template>

<script type="text/babel">
import LineChart from '../../components/lib/charts/LineChart.vue'
import PolarChart from '../../components/lib/charts/PolarChart.vue'
import BarChart from '../../components/lib/charts/BarChart.vue'
import HorizontalBarChart from '../../components/lib/charts/HorizontalBarChart.vue'
import DateRangePicker from "../../components/structure/DateRangePicker.vue";
import LoadingAnimation from '../../components/lib/LoadingAnimation.vue'
import BaseChart from '../../components/lib/charts/BaseChart.vue'
import HomeController from './controllers/Home.vue'
import ActionBar from '../../components/structure/ui/ActionBar.vue'
import KeplerBackofficeSdk from '../../lib/kepler/backoffice'
import store from '../../store'

import merge from 'deepmerge'
import moment from 'moment'


export default {
  name: 'BackofficeHome',
  components: {
    ActionBar,
    HomeController,
    BaseChart,
    LoadingAnimation,
    HorizontalBarChart,
    BarChart,
    PolarChart,
    LineChart,
    DateRangePicker,
  },

  watch: {
    'form.bracketing': {
      handler(val) {
        this.loadData()
      }
    },
  },
  mounted() {
    store.dispatch('getConfiguration')
  },
  created() {
    const start = moment().startOf('month').format('YYYY-MM-DD')
    const end = moment().format('YYYY-MM-DD')
    this.form.start = start
    this.form.end = end
    this.form = {
      start,
      end,
      bracketing: 'D'
    }
    this.myRange = {"start": this.form.start, "end": this.form.end}
    this.loadData()
  },
  methods: {

    dateRangeSelected(range) {
      this.form.start = range.start
      this.form.end = range.end
      if (this.form.start !== "" && this.form.end !== "" && this.form.end !== null) {
        this.loadData()
      }
    },
    loadData: function () {
      if (this.timeout) {
        clearTimeout(this.timeout)
        this.timeout = null
      }
      this.timeout = setTimeout(()=>{
        this.loadDataReal()
      }, 333)
    },
    loadDataReal: function () {
      const chartLoader = KeplerBackofficeSdk.charts.for(this.form.start, this.form.end, this.form.bracketing);

      if (this.$acl('charged-reservations-charts')) {
        chartLoader.charged_reservations((data) => {
          this.res = data
        })
      }
      if (this.$acl('driven-distance-charts')) {
        chartLoader.driven_distance((data) => {
          this.dis = data
        })
      }
      if (this.$acl('driver-registrations-charts') && this.$acl('client-registrations-charts')) {
        chartLoader.driver_registrations((drivers) => {
          chartLoader.client_registrations((clients) => {
            this.reg = merge(clients, drivers)
          })
        })
      }
      if (this.$acl('vehicle-reservations-charts') && this.$acl('vehicle-distance-charts')) {
        chartLoader.vehicle_reservations((res) => {
          chartLoader.vehicle_distance((dis) => {
            this.vei = merge(res, dis)
          })
        })
      }

      if (this.$acl('vehicles-by-zone-charts') && !this.loadingVeiByZ) {
        this.loadingVeiByZ = true
        chartLoader.vehicles_by_zone((res) => {
          this.loadingVeiByZ = false
          let temp = {}
          for (let key in res) {
            temp[key] = {vehicles: res[key]}
          }
          this.veiByZ = temp
        })
      }
    }
  },
  data() {
    return {
      form: {
        start: null,
        end: null,
        bracketing: null
      },
      myRange: null,
      formLoading: false,
      dis: null,
      res: null,
      reg: null,
      vei: null,
      veiByZ: null,
      loadingVeiByZ: false,
      timeout: null
    }
  }
}
</script>
<style lang="sass">
.map-wrapper
  width: 100%
  height: 768px


</style>



// WEBPACK FOOTER //
// Home.vue?0eceb61e